import { getOwner } from '@ember/application';
import Service from '@ember/service';
import { captureException, captureMessage } from '@sentry/browser';
import CatalogError from '@square/dashboard-data/utils/catalog/catalog-error';
import { isStatusCodeToIgnore } from '@square/dashboard-items-data/utils/sentry';
export default class CatalogSentry extends Service {
  captureException(exception, captureContext) {
    const xhrError = this.getXhrError(exception, captureContext);
    if (xhrError && isStatusCodeToIgnore(xhrError.xhrStatus ?? xhrError.status)) {
      return;
    }
    if (this.isProduction) {
      captureException(exception, captureContext);
      return;
    }
    if (this.isStaging) {
      captureException(exception, captureContext);
    }
    if (this.isTest) {
      return;
    }
    // eslint-disable-next-line no-console
    console.error('[SENTRY]', exception, '\nDetails', captureContext);
  }
  captureMessage(...args) {
    if (this.isProduction) {
      captureMessage(...args);
      return;
    }
    if (this.isStaging) {
      captureMessage(...args);
    }
    if (this.isTest) {
      return;
    }

    // eslint-disable-next-line no-console
    console.error('[SENTRY]', args[0]);
  }
  get isProduction() {
    return getOwner(this).resolveRegistration('config:environment').environment === 'production';
  }
  get isStaging() {
    return getOwner(this).resolveRegistration('config:environment').environment === 'staging';
  }
  get isTest() {
    return getOwner(this).resolveRegistration('config:environment').environment === 'test';
  }

  /*
   There are 2 ways of the CatalogSentry usage existing:
   1. this.catalogSentry.captureException(error, null);
   2. this.catalogSentry.captureException(new Error('Advanced Categories: some error message'), { extra: { errors } });
   and the "error" or "errors" can be original xhr or catalogError
  */
  getXhrError(exception, captureContext) {
    if (this.isCatalogErrorOrOriginalXhrError(exception)) {
      return exception;
    }
    if (captureContext && 'extra' in captureContext) {
      const errors = captureContext.extra?.errors;
      if (this.isCatalogErrorOrOriginalXhrError(errors)) {
        return errors;
      }
      if (Array.isArray(errors) && errors.length > 0) {
        const firstError = errors[0];
        if (this.isCatalogErrorOrOriginalXhrError(firstError)) {
          return firstError;
        }
      }
    }
    return null;
  }
  isCatalogErrorOrOriginalXhrError(error) {
    return error instanceof CatalogError && typeof error.xhrStatus === 'number' || typeof error?.status === 'number' && typeof error?.url === 'string';
  }
}